
import ConfigLocationNotFoundSvgComponent from "../../assets/svg-components/not-found/config-local";
import { NavLink } from "react-router-dom";
import './index.scss';


export default function ConfigLocationNotfound() {
  return (
    <>
      <div className="new-not-found-wrap">
        <div className="new-not-found-wrap__details config_vendors_not_found">
          {/* <img
            src="/images/page-not-found/config-loc.svg"
            className="not-found-image img-fluid not-found-image-config-vendors"
          /> */}
          <div className="not-found-image img-fluid not-found-image-config-vendors">
            <ConfigLocationNotFoundSvgComponent />
          </div>
          <p className="no-data-found-text no-data-found-text-config-vendors">Location not found. Please click the button below <br /> to add a new location</p>
          <button className='btn btn-primary btn-add-no-record'>
            <NavLink to={`/location/detail`} className="d-flex align-items-center color-white" >
              <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24"><path d="M11 19V13H5V11H11V5H13V11H19V13H13V19Z" fill="#ffffff"></path></svg>
                Add Location
            </NavLink>
          </button>
        </div>
      </div>
    </>
  );
}
